import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Grid } from "@mui/material";
import { Icons, Box, Card, IconButton } from "@curves/ui-base";
import { makeField } from "./tools";
import { ReadTextField } from "@icoach/components";
import { InvoiceDialog } from "./dialog";
import { useMemberProfileApi } from "@apis/useMemberProfileApi";
import { useMemberDetailContext } from "@icoach/memberDetail/MemberDetailContext";
import useMessageDialog from "@util/hook/useMessageDialog";
import { isEmpty, isEqual } from "@util/utils";

export const getInvoiceData = sourceData => {
	let { issuingType, carrierType, issuingTypeText, carrierTypeText, donationCode, carrierNo, taxID, taxTitle, invoiceNotes } = sourceData || {};

	if (String(carrierType) === "4") {
		return [makeField("issuingType", "發票開立方式", issuingTypeText), makeField("carrierType", "發票載具", carrierTypeText), makeField("donationCode", "備註", invoiceNotes)];
	} else {
		switch (String(issuingType)) {
			case "1":
				return [makeField("issuingType", "發票開立方式", issuingTypeText), makeField("donationCode", "愛心碼", donationCode), makeField("invoiceNotes", "備註", invoiceNotes)];
			case "2":
				return [
					makeField("issuingType", "發票開立方式", issuingTypeText),
					makeField("carrierType", "發票載具", carrierTypeText),
					makeField("carrierNo", "載具號碼", carrierNo || "無"),
					makeField("invoiceNotes", "備註", invoiceNotes),
				];
			default:
				return [
					makeField("issuingType", "發票開立方式", issuingTypeText),
					makeField("taxID", "統一編號", taxID),
					makeField("taxTitle", "發票抬頭", taxTitle),
					makeField("invoiceNotes", "備註", invoiceNotes),
				];
		}
	}
};

const ProfileInvoiceCard = props => {
	const { className, fields, title, handleOnEdit } = props;

	return (
		<Card className={clsx("profile-invoice-card", className)}>
			{handleOnEdit ? (
				<IconButton className="profile-invoice-card-btn" onClick={handleOnEdit}>
					<Icons.Edit />
				</IconButton>
			) : null}
			<Card.CardHeader title={title} />
			<Card.CardContent className="px-3 pb-3">
				<Grid container spacing={3}>
					{!isEmpty(fields) &&
						fields.map(({ label, value, id }) => (
							<Grid key={id} xs={6} item>
								<ReadTextField label={label}>{value}</ReadTextField>
							</Grid>
						))}
				</Grid>
			</Card.CardContent>
		</Card>
	);
};

const MemberDetailBasicInfoContentInvoice = props => {
	const { memberID } = props;
	const setMessageDialog = useMessageDialog();
	const { setRefresh } = useMemberDetailContext();
	const { getMemberProfileInvoicesApi } = useMemberProfileApi();
	const [memberInvoiceData, setMemberInvoiceData] = useState([]);
	const [dialogOpen, setDialogOpen] = useState({
		isOpen: false,
		current: null,
	});

	const doMemberProfileInvoicesApi = async memberID => {
		let resp = await getMemberProfileInvoicesApi(memberID);
		if (resp) {
			setMemberInvoiceData(resp);
		}
	};

	const handleOpenDialog = index => {
		setDialogOpen({
			isOpen: true,
			current: index,
		});
	};

	const handleCloseDialog = () => {
		setDialogOpen({
			isOpen: false,
			current: null,
		});
	};

	const handleEditInvoice = (index, invoiceData) => {
		const { sourceType } = invoiceData;
		if (String(sourceType) === "4") {
			setMessageDialog({
				open: true,
				title: "提醒",
				msg: "尚未開放，如需變更請洽總部人員",
			});
		} else {
			handleOpenDialog(index);
		}
	};

	useEffect(() => {
		if (memberID) {
			setRefresh(doMemberProfileInvoicesApi);
			doMemberProfileInvoicesApi(memberID);
		}
		// eslint-disable-next-line
	}, [memberID]);
	return (
		<Box className="mb-4">
			{!isEmpty(memberInvoiceData) &&
				memberInvoiceData.map((item, i) => {
					let ownerProperty = {
						className: `mb-4`,
						fields: getInvoiceData(item),
						title: item.title,
					};

					// SourceType: 4 循環訂單
					if (!isEqual(item.sourceType, 4)) {
						ownerProperty.handleOnEdit = () => handleEditInvoice(i, item);
					}

					return <ProfileInvoiceCard key={item.memberInvoiceID} {...ownerProperty} />;
				})}
			<InvoiceDialog open={dialogOpen.isOpen} sourceData={{ memberID, ...memberInvoiceData[dialogOpen.current] }} onClose={handleCloseDialog} />
		</Box>
	);
};

export default MemberDetailBasicInfoContentInvoice;
